/**
 * 消息通知类型与业务场景常量映射
 * 包含通用 Label 标签、Icon 图标及 CSS 色彩配置
 */

export const NOTIFICATION_TYPE_LABEL: Record<string, string> = {
  // 系统 / 账号 / 工单
  SYSTEM: '系统通知',
  system: '系统通知',
  ACCOUNT: '账号通知',
  account: '账号通知',
  SUBJECT: '认证通知',
  subject: '认证通知',
  CERTIFICATION: '认证通知',
  certification: '认证通知',
  MARKET_REVIEW: '入驻审核',
  market_review: '入驻审核',
  SUPPORT_TICKET: '系统工单',
  support_ticket: '系统工单',

  // 供需 / 方案 / 线索 / 内容审核
  DEMAND: '需求通知',
  demand: '需求通知',
  MARKET: '市场动态',
  market: '市场动态',
  JOB: '岗位动态',
  job: '岗位动态',
  JOB_APPLICATION: '岗位申请',
  job_application: '岗位申请',
  SOLUTION: '方案通知',
  solution: '方案通知',
  LEAD: '合作线索',
  lead: '合作线索',
  PROVIDER_COOPERATION_LEAD: '合作线索',
  provider_cooperation_lead: '合作线索',
  CONTENT_REVIEW: '内容审核',
  content_review: '内容审核',

  // 社区 / 评论
  COMMUNITY: '社区动态',
  community: '社区动态',
  COMMENT: '评论回复',
  comment: '评论回复',
  COMMENT_IMAGE: '评论图片',

  // 项目 / 发行 / 合同 / 渠道 / 营收 / 结算
  PROJECT: '项目动态',
  project: '项目动态',
  APPLICATION: '发行申请',
  application: '发行申请',
  APPLICATION_REVIEW: '发行申请',
  application_review: '发行申请',
  CONTRACT: '合同提醒',
  contract: '合同提醒',
  CHANNEL_RELEASE: '渠道发行',
  channel_release: '渠道发行',
  REVENUE: '营收结算',
  revenue: '营收结算',
  REVENUE_STATEMENT: '营收账单',
  revenue_statement: '营收账单',
  SETTLEMENT: '提现结算',
  settlement: '提现结算',

  // 学习资源 / 商城作品、订单、收益 / 运营
  LEARNING_RESOURCE: '课程动态',
  learning_resource: '课程动态',
  CATALOG: '商城动态',
  catalog: '商城动态',
  CATALOG_REVIEW: '作品审核',
  catalog_review: '作品审核',
  CATALOG_ORDER: '商城订单',
  catalog_order: '商城订单',
  CATALOG_INCOME: '作品收益',
  catalog_income: '作品收益',
  BANNER: '运营通知',
  banner: '运营通知',
};

export const NOTIFICATION_TYPE_ICONS: Record<string, string> = {
  SYSTEM: 'ri-notification-3-line',
  system: 'ri-notification-3-line',
  ACCOUNT: 'ri-user-settings-line',
  account: 'ri-user-settings-line',
  SUBJECT: 'ri-shield-check-line',
  subject: 'ri-shield-check-line',
  CERTIFICATION: 'ri-shield-check-line',
  certification: 'ri-shield-check-line',
  MARKET_REVIEW: 'ri-store-3-line',
  market_review: 'ri-store-3-line',
  SUPPORT_TICKET: 'ri-customer-service-2-line',
  support_ticket: 'ri-customer-service-2-line',

  DEMAND: 'ri-file-search-line',
  demand: 'ri-file-search-line',
  MARKET: 'ri-briefcase-line',
  market: 'ri-briefcase-line',
  JOB: 'ri-briefcase-line',
  job: 'ri-briefcase-line',
  JOB_APPLICATION: 'ri-briefcase-line',
  job_application: 'ri-briefcase-line',
  SOLUTION: 'ri-lightbulb-line',
  solution: 'ri-lightbulb-line',
  LEAD: 'ri-hand-coin-line',
  lead: 'ri-hand-coin-line',
  PROVIDER_COOPERATION_LEAD: 'ri-hand-coin-line',
  provider_cooperation_lead: 'ri-hand-coin-line',
  CONTENT_REVIEW: 'ri-draft-line',
  content_review: 'ri-draft-line',

  COMMUNITY: 'ri-chat-smile-3-line',
  community: 'ri-chat-smile-3-line',
  COMMENT: 'ri-message-3-line',
  comment: 'ri-message-3-line',

  PROJECT: 'ri-rocket-line',
  project: 'ri-rocket-line',
  APPLICATION: 'ri-send-plane-line',
  application: 'ri-send-plane-line',
  APPLICATION_REVIEW: 'ri-send-plane-line',
  application_review: 'ri-send-plane-line',
  CONTRACT: 'ri-file-text-line',
  contract: 'ri-file-text-line',
  CHANNEL_RELEASE: 'ri-share-forward-line',
  channel_release: 'ri-share-forward-line',
  REVENUE: 'ri-money-cny-circle-line',
  revenue: 'ri-money-cny-circle-line',
  REVENUE_STATEMENT: 'ri-file-list-3-line',
  revenue_statement: 'ri-file-list-3-line',
  SETTLEMENT: 'ri-bank-card-line',
  settlement: 'ri-bank-card-line',

  LEARNING_RESOURCE: 'ri-book-open-line',
  learning_resource: 'ri-book-open-line',
  CATALOG: 'ri-store-2-line',
  catalog: 'ri-store-2-line',
  CATALOG_REVIEW: 'ri-shield-user-line',
  catalog_review: 'ri-shield-user-line',
  CATALOG_ORDER: 'ri-shopping-bag-line',
  catalog_order: 'ri-shopping-bag-line',
  CATALOG_INCOME: 'ri-funds-box-line',
  catalog_income: 'ri-funds-box-line',
  BANNER: 'ri-flag-line',
  banner: 'ri-flag-line',
};

export const NOTIFICATION_TYPE_COLORS: Record<string, string> = {
  SYSTEM: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  system: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  ACCOUNT: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  account: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  SUBJECT: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  subject: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  CERTIFICATION: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  certification: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  MARKET_REVIEW: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  market_review: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  SUPPORT_TICKET: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  support_ticket: 'bg-emerald-50 text-emerald-600 border border-emerald-100',

  DEMAND: 'bg-amber-50 text-amber-600 border border-amber-100',
  demand: 'bg-amber-50 text-amber-600 border border-amber-100',
  MARKET: 'bg-teal-50 text-teal-600 border border-teal-100',
  market: 'bg-teal-50 text-teal-600 border border-teal-100',
  JOB: 'bg-teal-50 text-teal-600 border border-teal-100',
  job: 'bg-teal-50 text-teal-600 border border-teal-100',
  JOB_APPLICATION: 'bg-teal-50 text-teal-600 border border-teal-100',
  job_application: 'bg-teal-50 text-teal-600 border border-teal-100',
  SOLUTION: 'bg-amber-50 text-amber-600 border border-amber-100',
  solution: 'bg-amber-50 text-amber-600 border border-amber-100',
  LEAD: 'bg-orange-50 text-orange-600 border border-orange-100',
  lead: 'bg-orange-50 text-orange-600 border border-orange-100',
  PROVIDER_COOPERATION_LEAD: 'bg-orange-50 text-orange-600 border border-orange-100',
  provider_cooperation_lead: 'bg-orange-50 text-orange-600 border border-orange-100',
  CONTENT_REVIEW: 'bg-amber-50 text-amber-600 border border-amber-100',
  content_review: 'bg-amber-50 text-amber-600 border border-amber-100',

  COMMUNITY: 'bg-purple-50 text-purple-600 border border-purple-100',
  community: 'bg-purple-50 text-purple-600 border border-purple-100',
  COMMENT: 'bg-indigo-50 text-indigo-600 border border-indigo-100',
  comment: 'bg-indigo-50 text-indigo-600 border border-indigo-100',

  PROJECT: 'bg-sky-50 text-sky-600 border border-sky-100',
  project: 'bg-sky-50 text-sky-600 border border-sky-100',
  APPLICATION: 'bg-blue-50 text-blue-600 border border-blue-100',
  application: 'bg-blue-50 text-blue-600 border border-blue-100',
  APPLICATION_REVIEW: 'bg-blue-50 text-blue-600 border border-blue-100',
  application_review: 'bg-blue-50 text-blue-600 border border-blue-100',
  CONTRACT: 'bg-cyan-50 text-cyan-600 border border-cyan-100',
  contract: 'bg-cyan-50 text-cyan-600 border border-cyan-100',
  CHANNEL_RELEASE: 'bg-sky-50 text-sky-600 border border-sky-100',
  channel_release: 'bg-sky-50 text-sky-600 border border-sky-100',

  REVENUE: 'bg-rose-50 text-rose-600 border border-rose-100',
  revenue: 'bg-rose-50 text-rose-600 border border-rose-100',
  REVENUE_STATEMENT: 'bg-rose-50 text-rose-600 border border-rose-100',
  revenue_statement: 'bg-rose-50 text-rose-600 border border-rose-100',
  SETTLEMENT: 'bg-rose-50 text-rose-600 border border-rose-100',
  settlement: 'bg-rose-50 text-rose-600 border border-rose-100',

  LEARNING_RESOURCE: 'bg-teal-50 text-teal-600 border border-teal-100',
  learning_resource: 'bg-teal-50 text-teal-600 border border-teal-100',
  CATALOG: 'bg-teal-50 text-teal-600 border border-teal-100',
  catalog: 'bg-teal-50 text-teal-600 border border-teal-100',
  CATALOG_REVIEW: 'bg-teal-50 text-teal-600 border border-teal-100',
  catalog_review: 'bg-teal-50 text-teal-600 border border-teal-100',
  CATALOG_ORDER: 'bg-teal-50 text-teal-600 border border-teal-100',
  catalog_order: 'bg-teal-50 text-teal-600 border border-teal-100',
  CATALOG_INCOME: 'bg-teal-50 text-teal-600 border border-teal-100',
  catalog_income: 'bg-teal-50 text-teal-600 border border-teal-100',
  BANNER: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
  banner: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
};

/**
 * 格式化通知时间
 */
export function formatNotificationTime(timeStr?: string): string {
  if (!timeStr) return '';
  try {
    const d = new Date(timeStr);
    if (isNaN(d.getTime())) return timeStr;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } catch {
    return timeStr;
  }
}

/**
 * 根据通知消息获取对应业务跳转 URL
 */
export function getItemTargetUrl(item: Api.Notification.MessageResponse): string {
  const navCode = item.navigation_code || '';
  const params = item.navigation_params || {};
  const msgType = (item.message_type || '').toUpperCase();
  const relType = (item.related_type || '').toUpperCase();

  // 1. 如果 params 里包含直接跳转 url
  if (params.url) return params.url;

  // 2. 依据 navigation_code 进行路由匹配
  switch (navCode) {
    case 'CERTIFICATION_DETAIL':
      return '/certification';
    case 'PROVIDER_PROFILE_DETAIL':
      return '/provider-profile';

    case 'JOB_APPLICATION_DETAIL':
      return '/my/job-postings';

    case 'JOB_DETAIL':
    case 'JOB_POSTING_DETAIL': {
      const jobId = params.job_id || params.job_posting_id || params.id || item.related_id;
      return jobId ? `/jobs/${jobId}` : '/demands?tab=jobs';
    }

    case 'DEMAND_REVIEW_DETAIL':
      return params.demand_id ? `/demands/${params.demand_id}` : '/demands';
    case 'SOLUTION_REVIEW_DETAIL':
      return params.demand_id ? `/demands/${params.demand_id}` : '/my-bids';
    case 'LEAD_DETAIL':
    case 'PROVIDER_COOPERATION_LEAD_DETAIL':
      return '/my-leads';

    case 'APPLICATION_DETAIL':
    case 'APPLICATION_REVIEW_DETAIL':
    case 'EPISODE_REVIEW_DETAIL':
      return params.application_id ? `/applications/${params.application_id}` : '/applications';

    case 'PROJECT_DETAIL':
      return params.project_id ? `/projects/${params.project_id}` : '/projects';
    case 'PROJECT_CONTRACT':
      return params.contract_id
        ? `/contracts`
        : params.project_id
          ? `/projects/${params.project_id}`
          : '/contracts';
    case 'PROJECT_CHANNEL':
      return params.project_id ? `/projects/${params.project_id}` : '/projects';

    case 'REVENUE_STATEMENT_DETAIL':
      return '/revenue';
    case 'SETTLEMENT_PROFILE':
      return '/billing-profile';
    case 'SETTLEMENT_DETAIL':
      return '/revenue';

    case 'CATALOG_WORK_DETAIL':
    case 'CATALOG_WORK_REVIEW_DETAIL':
      return params.work_id ? `/courses/${params.work_id}` : '/courses';
    case 'CATALOG_ORDER_DETAIL':
      return '/orders';
    case 'CATALOG_MY_ACCESS':
      return params.work_id ? `/courses/${params.work_id}` : '/courses';
    case 'CATALOG_INCOME_DETAIL':
      return '/revenue';

    case 'COMMUNITY_DETAIL':
    case 'COMMUNITY_POST':
      return params.target_id ? `/community/${params.target_id}` : '/community';
    case 'SUPPORT_TICKET_DETAIL':
      return '/support-tickets';
  }

  // 3. 兜底策略
  if (
    msgType === 'COMMUNITY' ||
    msgType === 'COMMENT' ||
    msgType === 'COMMENT_IMAGE' ||
    relType.includes('COMMUNITY') ||
    relType.includes('COMMENT')
  ) {
    const targetId = params.target_id || item.related_id;
    return targetId ? `/community/${targetId}` : `/community`;
  }

  if (relType.includes('PROJECT') || msgType === 'PROJECT') {
    return item.related_id ? `/projects/${item.related_id}` : '/projects';
  }

  if (
    relType.includes('APPLICATION') ||
    msgType === 'APPLICATION_REVIEW' ||
    msgType === 'APPLICATION'
  ) {
    return item.related_id ? `/applications/${item.related_id}` : '/applications';
  }

  if (relType.includes('CONTRACT') || msgType === 'CONTRACT') {
    return '/contracts';
  }

  if (relType.includes('DEMAND') || msgType === 'DEMAND') {
    return item.related_id ? `/demands/${item.related_id}` : '/demands';
  }

  if (
    msgType === 'MARKET' ||
    msgType === 'JOB_APPLICATION' ||
    relType.includes('JOB_APPLICATION')
  ) {
    return '/my/job-postings';
  }

  if (
    msgType === 'JOB' ||
    relType.includes('JOB') ||
    relType.includes('MARKET')
  ) {
    const jobId = params.job_id || params.job_posting_id || params.id || item.related_id;
    return jobId ? `/jobs/${jobId}` : '/demands?tab=jobs';
  }

  if (relType.includes('LEAD') || msgType === 'LEAD') {
    return '/my-leads';
  }

  if (
    relType.includes('CERTIFICATION') ||
    msgType === 'CERTIFICATION' ||
    msgType === 'MARKET_REVIEW'
  ) {
    return '/certification';
  }

  if (
    relType.includes('SETTLEMENT') ||
    relType.includes('REVENUE') ||
    msgType === 'REVENUE_STATEMENT' ||
    msgType === 'SETTLEMENT' ||
    msgType === 'REVENUE'
  ) {
    return '/revenue';
  }

  if (relType.includes('CATALOG_ORDER') || msgType === 'CATALOG_ORDER') {
    return '/orders';
  }

  if (
    relType.includes('CATALOG') ||
    msgType.includes('CATALOG') ||
    relType.includes('LEARNING') ||
    relType.includes('COURSE') ||
    msgType === 'LEARNING_RESOURCE'
  ) {
    return item.related_id ? `/courses/${item.related_id}` : '/courses';
  }

  if (relType.includes('PROFILE') || relType.includes('ACCOUNT') || relType.includes('SUBJECT')) {
    return '/profile';
  }

  return '#';
}

